import { articles } from "@/mocks/homeData";
import { Link, useNavigate } from "react-router-dom";

export default function ArticleSection() {
  const navigate = useNavigate();

  const handleArticleClick = (slug: string) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    navigate(slug);
  };

  return (
    <section className="w-full py-16 md:py-20 px-6 md:px-10 lg:px-16 bg-secondary-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-6 mb-10 md:mb-14">
          <div className="lg:w-1/3">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 leading-tight">
              Guide e Articoli
              <br />
              SEO ItaoBuy
            </h2>
          </div>
          <div className="lg:w-2/3 flex items-end">
            <p className="text-foreground-600 text-sm md:text-base">
              Esplora la nostra raccolta di guide complete, tutorial passo passo e risorse ottimizzate per aiutarti a padroneggiare ItaoBuy Spreadsheet. Contenuti originali scritti da esperti del settore, aggiornati regolarmente per Google SEO.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article, idx) => (
            <button
              key={article.id}
              onClick={() => handleArticleClick(article.slug)}
              className={`group rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.02] text-left w-full ${
                idx === 0
                  ? "lg:col-span-2 lg:row-span-2 bg-accent-500"
                  : "bg-background-50 border border-background-200/70"
              }`}
            >
              <div className="relative overflow-hidden aspect-[16/10]">
                <img
                  src={article.image}
                  alt={article.title}
                  title={`${article.title} - ItaoBuy Spreadsheet`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                {article.label && (
                  <span className="absolute top-3 left-3 px-3 py-1 bg-background-50/90 backdrop-blur-sm rounded-full text-xs font-medium text-accent-500 whitespace-nowrap">
                    {article.label}
                  </span>
                )}
              </div>
              <div className="p-5 md:p-6">
                <h3
                  className={`font-heading text-lg md:text-xl font-bold mb-2 line-clamp-2 ${
                    idx === 0 ? "text-white" : "text-foreground-900"
                  }`}
                >
                  {article.title}
                </h3>
                <p
                  className={`text-xs md:text-sm leading-relaxed line-clamp-3 ${
                    idx === 0 ? "text-white/75" : "text-foreground-600"
                  }`}
                >
                  {article.excerpt}
                </p>
                <div className="mt-4">
                  <span
                    className={`inline-flex items-center gap-1.5 text-xs font-medium ${
                      idx === 0 ? "text-white/60" : "text-accent-500"
                    }`}
                  >
                    Leggi l&apos;articolo
                    <span className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-arrow-right-line"></i>
                    </span>
                  </span>
                </div>
              </div>
            </button>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-sm text-foreground-500 hover:text-accent-500 transition-colors cursor-pointer"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-home-4-line"></i>
            </span>
            Torna alla Home di ItaoBuy Spreadsheet
          </Link>
        </div>
      </div>
    </section>
  );
}